<template>
  <path
    d="M11 6.5L6 1.5L1 6.5"
    stroke="#94969C"
    stroke-width="1.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
